/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_No_Readable_TextInputs */

const en_conversion_error_no_readable_text = /** @type {(inputs: Conversion_Error_No_Readable_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document does not contain readable text.`)
};

const es_conversion_error_no_readable_text = /** @type {(inputs: Conversion_Error_No_Readable_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este documento no contiene texto legible.`)
};

/**
* | output |
* | --- |
* | "This document does not contain readable text." |
*
* @param {Conversion_Error_No_Readable_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_no_readable_text = /** @type {((inputs?: Conversion_Error_No_Readable_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_No_Readable_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_no_readable_text(inputs)
	return en_conversion_error_no_readable_text(inputs)
});